import './index.css'
import { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { PADDING_BASE } from "../../assets/Styles"
import { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow } from "./scheme"
import Copyright from "../common/Copyright"
import PageContainer from "../common/PageContainer"
import { Link, useNavigate } from "react-router-dom"
import { useProject } from "../../context/ProjectContext"
import { filterAreas } from "../../services/company.service"
import DataTable from "../common/DataTable2"
import Breadcrumbs from "../common/Breadcrumbs"
import useUser from "../../hooks/useUser"
import { AreasFilterFormModel, DataArea } from "../../models/area.model"
import PrimaryMenuBar from "../AreaActions/AreasListingActions/PrimaryMenuBar"
import { useNotification } from '../../context/NotificationContext'


export default function AreasListing(props: any) {
  const setBlockScreen = props.setBlockScreen
  
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();
  
  const { userAdmin } = useUser()

  const navigate = useNavigate()

  const [areasList, setAreasList] = useState<DataArea[]>([]);
  const [loading, setLoading] = useState<boolean>(false)

  const defaultAreasFilter: AreasFilterFormModel = {
    id: '',
    name: '',
    from: '',
    to: '',
    project_id: selectedProject
  }

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([setTimeout(() => { }, 500)]).then(function (result: any[]) {
      setBlockScreen(false)
    }).catch((error) => {
      setBlockScreen(false)
    })
  };

  useEffect(initComponent, [])

  const setFilter = () => {
    setLoading(true)
    Promise.all([filterAreas(selectedProject, {})]).then(function (results) {
      setAreasList(results[0])
      setLoading(false)
    }).catch((error) => {
      showNotification(error.response?.data, 'error')
      setLoading(false)
    });
  }

  useEffect(setFilter, [selectedProject])

  const handleDoubleClickArea = (rowData: DataArea) => {
    handleDoubleClickRow(selectedProject, rowData.code, navigate)
  }

  return (
    <>
      <PageContainer>

        <Box paddingBottom={PADDING_BASE}>
          <Breadcrumbs
            pathlist={[
              <Link className="breadcrumbs-nav__link" to="/tickets/listing">Home</Link>, 'Áreas'
            ]} />
        </Box>

        <div className="areas-listing-section">
          <PrimaryMenuBar
            handleOpenFilter={() => { }}
            setSearch={setFilter}
            resetPrimaryFilter={() => { }}
            defaultSearchForm={defaultAreasFilter}
            selectedProject={selectedProject}
            canEdit={userAdmin}
          />

          <DataTable
            columns={TableSchema}
            rows={areasList.map((row) => rowDataPreprocesor(row, selectedProject))}
            onRowDoubleClick={handleDoubleClickArea}
            loading={loading}
            columnId={columnId}
            onClickIdValue={handleDoubleClickArea}
          />
        </div>

      </PageContainer>
      <Copyright marginBottom={'1rem'} />

    </>
  )
}
